import * as React from "react";

import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';

import { useContext } from "react";
import PageContext from "./Context/PageContext";

import { HandleStyles, Rnd } from "react-rnd";

import $ from "jquery";

import "@maptiler/sdk/dist/maptiler-sdk.css";

import { isMobile } from "react-device-detect";
import { createMapElementAction, createOneValueElementAction } from "./history/element.history";

export default function Lab() {

    const { isDraggableMap, zoomValue, mapPosition, setMapPosition, mapIndex, mapTaille, setMapTaille, selectedItem, setSelectedItem, setSelectedItemIsLock, selectedItemIsLock,
        cropCadreImage, setCropCadreImage, cropImage, setCropImage, history, mapLock } = useContext(PageContext);

    const rndRef = React.useRef<Rnd | null>(null);
    const [zoom, setZoom] = React.useState(1);
    const [isResize, setIsResize] = React.useState(false);
    const [isSelectedItem, setIsSelectedItem] = React.useState(false);

    const val = mapTaille;

    //Utiliser pour définir la taille des corner resize
    //valeur du corner invisible (plus grand que celui visible pour faciliter l'action)
    var sizeCornerResizeSize = isMobile ? 20 / zoomValue : 15 / zoomValue;
    var sizeCornerResizeAbsolute = sizeCornerResizeSize / 2;
    const epaisseurBordure = 6;
    const epaisseurBordureTopBottom = epaisseurBordure / 2;
    const maxWidthORHeightCorner = isMobile ? 150 : 100;

    //use for import new modele or template
    React.useEffect(() => {
        if (rndRef.current != null) rndRef.current.updateSize({ width: mapTaille.width, height: mapTaille.height });
    }, [mapTaille]);

    React.useEffect(() => {
        if (rndRef.current != null) {
            rndRef.current.updatePosition({ x: mapPosition.x, y: mapPosition.y });
        }
    }, [mapPosition]);

    React.useEffect(() => {
        if (selectedItem != null && "mapbox-id" == selectedItem.id) {
            setIsSelectedItem(true)
            setIsResize(true);
            $('#mapbox-id').find('.map-element').css('pointer-events', 'auto');
        } else {
            setIsSelectedItem(false);
            setIsResize(false);
            //désactiver déplacement interne de carte
            $('#mapbox-id').find('.map-element').css('pointer-events', 'none');
        }

    }, [selectedItem])

    React.useEffect(() => {
        //on passe par le callback de isSelectedItem, car l'objet devient dragable quand setIsSelectedItem est appellé
        //On remplace le contenu de clone_div (en 1er plan) par le span qui contient les corner resize
        //attention au mode texte on fait pas ?

        if (isSelectedItem) {

            let cloneDiv = $("#clone-mapbox-id");

            let spanClone = $('#' + selectedItem.id)!.find("span").last();
            if (cloneDiv != null && spanClone != null && cloneDiv.html() == "") cloneDiv.append(spanClone);
            //update clone div position and size
            cloneDiv.css({ top: mapPosition.y, left: mapPosition.x, width: mapTaille.width, height: mapTaille.height, position: 'absolute' });


        }
    }, [isSelectedItem]);

    function updateSizeElement(ref: any, position: any) {

        //move spanClone into an above div (1er plan)
        $("#clone-" + selectedItem!.id).css({ top: position.y, left: position.x, width: ref.offsetWidth, height: ref.offsetHeight, position: 'absolute' });

        if (ref.offsetWidth < maxWidthORHeightCorner || ref.offsetHeight < maxWidthORHeightCorner) $("#clone-" + selectedItem!.id).find(".corner-resize-bottomLeft").show();
        else $("#clone-" + selectedItem!.id).find("div[class^='corner-resize-']").show();

    }

    function onSizeElement(e: any, ref: any, delta: any, position: any) {
        var backPosition = { x: mapPosition.x, y: mapPosition.y, width: mapTaille.width, height: mapTaille.height }

        //move spanClone into an above div (1er plan)
        $("#clone-" + selectedItem!.id).css({ top: position.y, left: position.x, width: ref.offsetWidth, height: ref.offsetHeight, position: 'absolute' });
        $("#clone-" + selectedItem!.id).find("div[class^='corner-resize-']").hide();

        if (setMapTaille != null) setMapTaille({ height: ref.offsetHeight, width: ref.offsetWidth });
        if (setMapPosition != null) setMapPosition({ x: position.x, y: position.y })


        var action = createMapElementAction(
            backPosition,
            { x: position.x, y: position.y, width: ref.offsetWidth, height: ref.offsetHeight },
            { setMapPosition, setMapTaille, isSelectedItem }
        );

        history.add(action);

    }

    /* set selectedItem, check if it is lock, set css selected element to selected element, remove from other obj css*/
    function selectElement(event: React.MouseEvent<HTMLElement>) {

        var element = event.currentTarget;

        //si on click sur le meme element déjà selectionner on fait rien
        if (setSelectedItem != null && element != null && selectedItem != null && element.id == selectedItem.id) {
            //on fait rien pour garantir que contenteditable fonctionne
        }
        else if (setSelectedItem != null) {
            setSelectedItem(element);
        }
        if (element != null) {

            //close collapse opacity
            //if (setIsOpenOpacity != null) setIsOpenOpacity(false);
            //close position section
            //if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('')

            //const item = objItems.find(item => item.id === element?.id);
            /* test if this object is lock */
            //

            //a supp
            /*var isLock = $('#' + element.id).find('.map-element').css('pointer-events') == 'none' ? true : false;*/
            if (mapLock) {
                //console.log(mapLock)
                if (setSelectedItemIsLock != null) { setSelectedItemIsLock(mapLock); }
            }

            //Cas spécial pour l'élément texte, on supprime les bordures active
            $('.text-eleme-active').remove();

            if (cropCadreImage != null) $("#img-" + cropCadreImage.originalId).css('visibility', 'visible');
            if (setCropCadreImage != null) setCropCadreImage(null)

            if (cropImage != null && setSelectedItem != null && element != null && element.id != cropImage.id) {
                //avec cropImage on créer une copie de l'élément image, si on le ferme, on remet l'image initiale et son clone container que l'on masqué
                $("#" + cropImage.id).css('visibility', 'visible');
                $("#clone-container-" + cropImage.id).css('display', 'block');
                if (setCropImage != null) setCropImage(null)
            }
        }

    }

    function updatePositionElement(e: any, position: any) {

        let cloneDiv = $("#clone-mapbox-id");

        if (position.node.offsetWidth < maxWidthORHeightCorner || position.node.offsetHeight < maxWidthORHeightCorner)
            cloneDiv.find(".corner-resize-bottomLeft").show();
        else
            cloneDiv.find("div[class^='corner-resize-']").show();

        //move spanClone into an above div (1er plan)
        cloneDiv.css({ top: position.y, left: position.x, width: position.node.offsetWidth, height: position.node.offsetHeight, position: 'absolute' });

        var backPosition = { x: mapPosition.x, y: mapPosition.y, width: mapTaille.width, height: mapTaille.height }

        if (setMapPosition != null) setMapPosition({ x: position.x, y: position.y })

        setZoom(1)

        $('#mapbox-id').find('.map-element').css('pointer-events', 'auto');

        var action = createMapElementAction(
            backPosition,
            { x: position.x, y: position.y, width: mapTaille.width, height: mapTaille.height },
            { setMapPosition, setMapTaille, isSelectedItem }
        );

        history.add(action);


    }

    function onDragElement(e: any, position: any) {
        //le param scale permet gérer la vitesse du drag, mais pose des problèmes de position
        //le fait de le remettre à 1 à la fin du drag resoud le pb

        //pour éviter que la map bouge pendant le drag
        $('#mapbox-id').find('.map-element').css('pointer-events', 'none');

        if (isSelectedItem) {
            let cloneDiv = $("#clone-" + selectedItem!.id);

            //move spanClone into an above div (1er plan)
            cloneDiv.find("div[class^='corner-resize-']").hide();
            cloneDiv.css({ top: position.y, left: position.x, width: position.node.offsetWidth, height: position.node.offsetHeight, position: 'absolute' });

            setZoom(zoomValue)
        }
    }

    const cssProp: React.CSSProperties = {
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: '0 0 4px 1px rgba(57, 76, 96, .15), 0 0 0 1px rgba(43, 59, 74, .3)',
        zIndex: 999
    }

    const cssPropLine: React.CSSProperties = {
        backgroundColor: '#8b3dff',
        zIndex: 999
    }

    const cornerStyle: HandleStyles = {
        bottom: { ...cssPropLine, height: epaisseurBordure, bottom: -epaisseurBordureTopBottom },
        bottomLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        bottomRight: { ...cssProp, right: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        left: { ...cssPropLine, width: epaisseurBordure, left: -epaisseurBordureTopBottom },
        right: { ...cssPropLine, width: epaisseurBordure, right: -epaisseurBordureTopBottom },
        top: { ...cssPropLine, height: epaisseurBordure, top: -epaisseurBordureTopBottom },
        topLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        topRight: { ...cssProp, right: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    }

    return (
        <Rnd
            id='mapbox-id'
            resizeHandleStyles={cornerStyle}
            style={{ zIndex: mapIndex + 1, touchAction: selectedItem != null ? 'none' : 'auto' }}
            ref={rndRef}
            default={{
                x: mapPosition.x,
                y: mapPosition.y,
                width: mapTaille.width,
                height: mapTaille.height,
            }}
            enableResizing={
                { top: isResize, right: isResize, bottom: isResize, left: isResize, topRight: isResize, bottomRight: isResize, bottomLeft: isResize, topLeft: isResize }}
            onResize={(e, direction, ref, delta, position) => {
                updateSizeElement(ref, position)
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                onSizeElement(e, ref, delta, position);
            }}
            onClick={selectElement}
            disableDragging={!isDraggableMap}
            onDrag={(e, d) => { onDragElement(e, d) }}
            onDragStop={(e, d) => { updatePositionElement(e, d) }}
            //dragGrid={[5, 5]}
            scale={zoomValue}
        >
            <MapBox />
        </Rnd>
    );
}

function MapBox() {

    const { isDraggableMap, mapPosition, setMapPosition, mapTaille, mapUrlStyle, mapZoom, setMapZoom, mapCenter, setMapCenter, history, mapLock } = useContext(PageContext);

    // this is where the map instance will be stored after initialization
    const [map, setMap] = React.useState<mapboxgl.Map>();

    // React ref to store a reference to the DOM node that will be used
    // as a required parameter `container` when initializing the mapbox-gl
    // will contain `null` by default
    const mapNode = React.useRef(null);

    //ref miroir car dans le on map on a pas la valeur à jour
    const mapZoomRef = React.useRef<number | null>(null);
    const mapCenterRef = React.useRef<any | null>(null);
    const mapLockRef = React.useRef<any>();

    React.useEffect(() => {
        mapLockRef.current = mapLock;
    }, [mapLock]);

    // getters live
    const getMapLockRef = () => mapLockRef.current;

    React.useEffect(() => {
        mapZoomRef.current = mapZoom;
    }, [mapZoom]);

    React.useEffect(() => {
        mapCenterRef.current = mapCenter;
    }, [mapCenter]);

    React.useEffect(() => {
        if (!map) return;

        if (mapLock) {
            map.dragPan.disable();
            map.scrollZoom.disable();
            map.doubleClickZoom.disable();
            map.touchZoomRotate.disable();
        } else {
            map.dragPan.enable();
            map.scrollZoom.enable();
            map.doubleClickZoom.enable();
            map.touchZoomRotate.enable();
        }
    }, [mapLock]);

    // target elements with the "draggable" class
    /*interact('.map-draggable')
        .draggable({
            enabled: isDraggableMap,
            // enable inertial throwing
            inertia: true,
            // keep the element within the area of it's parent
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'parent',
                    endOnly: true
                })
            ],
            // enable autoScroll
            autoScroll: true,

            listeners: {
                // call this function on every dragmove event
                move: dragMoveListener,

                // call this function on every dragend event
                end(event) {
                    var textEl = event.target.querySelector('p')

                    textEl && (textEl.textContent =
                        'moved a distance of ' +
                        (Math.sqrt(Math.pow(event.pageX - event.x0, 2) +
                            Math.pow(event.pageY - event.y0, 2) | 0))
                            .toFixed(2) + 'px')
                }
            }
        })*/

    /* function dragMoveListener(event: any) {
         var target = event.target
         // keep the dragged position in the data-x/data-y attributes
         var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
         var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
 
         // translate the element
         target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
 
         // update the posiion attributes
         target.setAttribute('data-x', x)
         target.setAttribute('data-y', y)
 
         if (setMapPosition != null) setMapPosition({ x: x, y: y })
     }*/

    function overrideZoomMobile(mapboxMap: any) {
        var dist1 = 0;

        // Example of a MapTouchEvent of type "touch"
        mapboxMap.on('touchstart', (e: { originalEvent: { touches: string | any[]; }; preventDefault: () => void; }) => {

            if (!getMapLockRef()) {
                if (e.originalEvent.touches.length === 2) {
                    dist1 = Math.hypot( //get rough estimate of distance between two fingers
                        e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX,
                        e.originalEvent.touches[0].pageY - e.originalEvent.touches[1].pageY);

                    e.preventDefault();
                }
            }
        });

        mapboxMap.on('touchmove', (e: { originalEvent: { touches: string | any[]; }; preventDefault: () => void; }) => {
            
            if (!getMapLockRef()) {
                
                if (e.originalEvent.touches.length === 2) {
                    var dist2 = Math.hypot(//get rough estimate of new distance between fingers
                        e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX,
                        e.originalEvent.touches[0].pageY - e.originalEvent.touches[1].pageY);
                    //alert(dist);
                    if (dist1 > dist2) {//if fingers are closer now than when they first touched screen, they are pinching
                        mapboxMap.setZoom(mapboxMap.getZoom() - 0.03);
                    }
                    if (dist1 < dist2) {//if fingers are further apart than when they first touched the screen, they are making the zoomin gesture
                        mapboxMap.setZoom(mapboxMap.getZoom() + 0.03);
                    }

                    e.preventDefault();
                }
            }

        });
    }

    function overrideZoomDesktop(mapboxMap: any) {
        const cont = document.getElementById('mapbox-id') as HTMLElement;
        const editeur = document.getElementById('editor-container') as HTMLElement;
        cont.onmouseover = function () {
            //disable scroll temporarily
            $('.editor-container').on('scroll mousewheel', function (e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            })

        };
        cont.onmouseout = function () {
            //active scroll 
            $('.editor-container').off('scroll mousewheel');
        };


        //override zoom function 
        mapboxMap.on("wheel", (event: { originalEvent: { deltaY: number; }; preventDefault: () => void; }) => {
            //seulement si nous locker
            //console.log(getMapLockRef())
            if (!getMapLockRef()) {
                if (event.originalEvent.deltaY < 0) {
                    mapboxMap.setZoom(mapboxMap.getZoom() + 0.1);
                }
                else if (event.originalEvent.deltaY > 0) {
                    mapboxMap.setZoom(mapboxMap.getZoom() - 0.1);
                }
            }

            //disable initial mapbox scroll function 
            event.preventDefault();
        });
    }


    React.useEffect(() => {
        const node = mapNode.current;
        // if the window object is not found, that means
        // the component is rendered on the server
        // or the dom node is not initialized, then return early
        if (typeof window === "undefined" || node === null) return;

        //maptilersdk.config.apiKey = 'tbAdsNC3IekU21e8XavJ';

        // otherwise, create a map instance
        /**/const mapboxMap = new mapboxgl.Map({
            container: node,
            accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN != null ? process.env.REACT_APP_MAPBOX_ACCESS_TOKEN : "",
            style: mapUrlStyle,
            center: [0.683333, 47.383333],
            zoom: 4,
            //pitch: 80,
            //bearing: 41,
            preserveDrawingBuffer: true,
        });

        mapboxMap.scrollZoom.enable({ around: 'center' });
        //mapboxMap.scrollZoom.disable();
        mapboxMap.setProjection('mercator');

        // https://stackoverflow.com/questions/48149766/mapbox-how-to-control-map-zooming-speed-in-a-mouse-scroll

        /**/if (navigator.userAgent.indexOf("Firefox") < 0) {
            overrideZoomDesktop(mapboxMap);
            overrideZoomMobile(mapboxMap);
        }


        //history
        const onZoomEnd = () => {
            const zoom = mapboxMap.getZoom();
            if (setMapZoom != null) setMapZoom(zoom);

            //a l'initialisation, pas tjr de valeur de zoom, prevent
            if (mapZoomRef.current != null) {
                let action = createOneValueElementAction({
                    target: "map-zoom",
                    item: null,
                    from: mapZoomRef.current,
                    to: zoom,
                    context: { setMapZoom }
                });

                history.add(action);
            }

        };

        //desktop
        mapboxMap.on("wheel", onZoomEnd);
        //mobile
        mapboxMap.on("touchend", onZoomEnd)

        const onMove = () => {
            var center = mapboxMap.getCenter();
            if (setMapCenter != null) setMapCenter(center);

            if (mapCenterRef.current != null) {
                let action = createOneValueElementAction({
                    target: "map-center",
                    item: null,
                    from: mapCenterRef.current,
                    to: center,
                    context: { setMapCenter }
                });

                history.add(action);
            }
        };

        mapboxMap.on("dragend", onMove);

        /*const mapboxMap = new maptilersdk.Map({
            container: node, // container's id or the HTML element to render the map
            style: maptilersdk.MapStyle.STREETS,
            center: [16.62662018, 49.2125578], // starting position [lng, lat]
            zoom: 14, // starting zoom
            preserveDrawingBuffer: true,
          });
    
    
    
    
       mapboxMap.setPixelRatio(2);*/

        // Add zoom and rotation controls to the map.
        //commentaire pr test maptiler sdk !!!!!!!!!!!
        if (!isMobile) mapboxMap.addControl(new mapboxgl.NavigationControl());

        //pour le 3d
        /*mapboxMap.on('style.load', () => {
            mapboxMap.addSource('mapbox-dem', {
                'type': 'raster-dem',
                'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
                'tileSize': 512,
                'maxzoom': 14
            });
            // add the DEM source as a terrain layer with exaggerated height
            mapboxMap.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2 });
        });*/

        // save the map object to React.useState
        //commentaire pr test maptiler sdk !!!!!!
        //setMap(mapboxMap);

        //On définit un observateur sur la map pour le redimensionnement*/
        /**/const myObserver = new ResizeObserver(entries => {
            if ((window as any).$map != undefined) (window as any).$map.resize()
        });

        myObserver.observe(node);

        (window as any).$map = mapboxMap;
        setMap(mapboxMap)

        return () => {
            mapboxMap.remove();
            mapboxMap.off("wheel", onZoomEnd);
            mapboxMap.off("touchend", onZoomEnd)
            mapboxMap.off("dragend", onMove);
        };
    }, []);

    return <div className="map-element map-draggable" style={{ height: '100%', width: '100%' }} data-x={mapPosition.x} data-y={mapPosition.y} ref={mapNode} />;
}


